export default "__VITE_ASSET__553a6f2e__"